import {
  Box, Flex, Text, InputGroup, InputLeftElement, Input, Popover, PopoverTrigger, PopoverContent,
  PopoverCloseButton, PopoverBody, Badge, Image, Checkbox, Tooltip, Select, Button, Modal, ModalOverlay,
  ModalContent, ModalCloseButton, ModalBody, Textarea, ModalHeader, ModalFooter, Divider, useDisclosure,
} from '@chakra-ui/react';
import { Search2Icon, CalendarIcon } from '@chakra-ui/icons';
import FilterIcon from '../../../../assets/images/Filter.svg';
import SortIcon from '../../../../assets/images/SortIcon.svg';
import { AlertCard, CustomToast, FilterPopover } from '../../../../components';
import MyDiv from './regularisationList.style';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as routesNames from '../../../../constants/routes';
import { RegularizationData } from '../../Regularisation/regularisation';
import { baseUrl, useFetch } from '../../../../hooks/useFetch';
import { showDate } from '../../../../utilities/helper';
import { IFilterOptions } from '../../../../components/FilterCard/filterCard';
import DateRangePicker from '../../../../components/DateRangePicker/DateRangePicker';
import CustomTables, { Column, ILazyParams } from '../../../../components/CustomTable/CustomTables';

export const getStatusName = (status: number) => {
  switch (status) {
    case 1: return 'Present';
    case 0: return 'Absent';
    case 2: return 'Half Day'
    case 3: return "Late"
    case 4: return "Early Out"
    case 5: return "Punch In Missing";
    case 6: return "Punch Out Missing";
    case 7: return "Week Off";
    case 8: return "Holiday";
    case 9: return "Short Leave";
    case 10: return "SL- Half day";
  }
};
export const getStatusClass = (status: number) => {
  switch (status) {
    case 1: return 'status_badge green';
    case 0: return 'status_badge red';
    case 2: return 'status_badge orange';
    case 3: return 'status_badge yellow';
    case 4: return 'status_badge purple';
    case 5: return 'status_badge blue';
    case 6: return 'status_badge pink';
    case 7: return 'status_badge cyan';
    case 8: return 'status_badge green';
    case 9: return 'status_badge teal';
    case 10: return 'status_badge amber';
    default: return 'status_badge gray';
  }
};

export const calculateWorkingHours = (inTime?: string, outTime?: string): string => {
  if (!inTime || !outTime) return "--";
  const parseTime = (t: string) => {
    const parts = t.split(':').map(Number);
    return (parts[0] || 0) * 60 + (parts[1] || 0);
  };
  const inMins = parseTime(inTime);
  let outMins = parseTime(outTime);
  if (outMins < inMins) outMins += 24 * 60;
  const diffMins = outMins - inMins;
  if (diffMins <= 0) return "--";
  const h = Math.floor(diffMins / 60);
  const m = diffMins % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')} hrs`;
};

const sortOptions = [
  'Check-In Time (Earliest to Latest)',
  'Check-In Time (Latest to Earliest)',
  'Check-Out Time (Earliest to Latest)',
  'Check-Out Time (Latest to Earliest)',
  'Name (A–Z)',
  'Name (Z–A)',
];
const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
  'Name (A–Z)': { field: 'name', order: 1 },
  'Name (Z–A)': { field: 'name', order: -1 },
  'Check-In Time (Earliest to Latest)': { field: 'inTime', order: 1 },
  'Check-In Time (Latest to Earliest)': { field: 'inTime', order: -1 },
  'Check-Out Time (Earliest to Latest)': { field: 'outTime', order: 1 },
  'Check-Out Time (Latest to Earliest)': { field: 'outTime', order: -1 },
};

export type RegularisationLazyParams = ILazyParams & { from?: string; to?: string };

interface RegularisationListProps {
  setAlertStatus: any,
  employees: any[];
  selectedRows: any[];
  setSelectedRows: (id: any) => void;
  toggleRow: (id: any) => void;
  toggleAll: () => void;
  handleStatusChange: (status: boolean) => void;
  alertStatus: any;
  confirmStatusChange: () => void;
  setSearchTerm: (term: string) => void;
  searchTerm: string;
  selectedStatus: number[];
  setSelectedStatus: (status: number[]) => void;
  lazyParams: RegularisationLazyParams;
  setLazyParams: React.Dispatch<React.SetStateAction<any>>;
  totalCount: number;
  loading: boolean;
  rejectReason: string;
  setRejectedReason: (reason: any) => void,
  loadingState: boolean;
  setLoadingState: (loading: boolean) => void;
  approveReason: string;
  setApproveReason: (reason: any) => void
  filter: IFilterOptions;
  setAppliedFilter: React.Dispatch<React.SetStateAction<Record<string, number[]>>>
  pageCount?: number;
  handlePageClick?: ({ selected }: { selected: number }) => void;
  setRowsPerPage?: (rows: number) => void;
}

const getStatusLabel = (status: boolean | null): "Pending" | "Approved" | "Rejected" => {
  if (status === null) return "Pending";
  if (status === true) return "Approved";
  if (status === false) return "Rejected";
  return "Pending";
};

const RegularisationList = ({
  loadingState, setAlertStatus, employees, selectedRows, setAppliedFilter, setSelectedRows, toggleRow, toggleAll,
  alertStatus, confirmStatusChange, setSearchTerm, searchTerm, lazyParams, setLazyParams, totalCount, loading,
  rejectReason, setRejectedReason, approveReason, setApproveReason, filter,
}: RegularisationListProps) => {
  const sortPop = useDisclosure();
  const [selected, setSelected] = useState<string>(sortOptions[0]);
  const navigate = useNavigate();
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [approvedModalOpen, setApprovedModalOpen] = useState(false);
  const { addToast } = CustomToast();
  const [showproof, setShowProof] = useState(false);
  const [documentUrl, setDocumentUrl] = useState<string | null>(null);
  const [documentType, setDocumentType] = useState<string | null>(null);
  const { fetchApi } = useFetch(addToast);
  const [punchModalOpen, setPunchModalOpen] = useState(false);
  const [punchLogs, setPunchLogs] = useState<any>(null);
  const [punchEmp, setPunchEmp] = useState<RegularizationData | null>(null);

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [dateRange, setDateRange] = useState({ from: firstDayOfMonth, to: today });

  const formatDate = (date: string | Date) => {
    const d = new Date(date);
    const offsetDate = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    return offsetDate.toISOString().split('T')[0];
  };

  useEffect(() => {
    if (dateRange.from && dateRange.to) {
      setLazyParams((prev: any) => ({
        ...prev,
        from: formatDate(dateRange.from),
        to: formatDate(dateRange.to),
        first: 0,
      }));
    }
  }, [dateRange]);

  const handleViewPunchLogs = async (emp: RegularizationData) => {
    setPunchEmp(emp);
    setPunchModalOpen(true);
    const response = await fetchApi(
      "Hrlense_Attendance/punchLogs", "GET", "", `employeeId=${emp.empId}&date=${formatDate(emp.dateOfRegularisation)}`
    );
    if (response) setPunchLogs(response);
  };

  const navigateToDetail = (employeeId: number, date?: string | Date) => {
    navigate(routesNames.REGULARISATIONDETAIL, { state: { employeeId, date } });
  };

  const handleSelect = (option: string) => {
    setSelected(option);
    const { field, order } = sortMapping[option];
    setLazyParams((prev: any) => ({ ...prev, sortField: field, sortOrder: order, first: 0 }));
    sortPop.onClose();
  };

  const fetchDocument = async (id: string | number) => {
    try {
      const res = await fetch(`${baseUrl}Regularization/proof/${id}`, {
        method: 'GET',
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setDocumentUrl(url);
      setDocumentType(blob.type);
      setShowProof(true);
    } catch (err) {
    }
  };

  const selectable = employees.filter((emp) => emp.status === null && emp.canApprove);
  const allSelected = selectable.length > 0 && selectable.every((emp) => selectedRows.includes(emp.id));
  const someSelected = selectable.some((emp) => selectedRows.includes(emp.id));

  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_medium text_lg">Regularisation Employee List</Text>
          <Flex className="filter_section">
            {selectedRows.length > 0 && (
              <Select placeholder="Bulk Action" width="150px" size="md" mt={2}
                onChange={(e) => {
                  const action = e.target.value;
                  if (selectedRows.length === 0) {
                    alert("Select at least one record");
                    return;
                  }
                  if (action === "Rejected") {
                    setRejectModalOpen(true);
                    return;
                  }
                  if (action === "Approved") {
                    setApprovedModalOpen(true);
                    return;
                  }
                }}
              >
                <option value="Approved">Approve</option>
                <option value="Rejected">Reject</option>
              </Select>
            )}

            <InputGroup mt={2} width="250px" height="25px">
              <InputLeftElement pointerEvents="none">
                <Search2Icon color="rgba(102, 112, 133, 1)" />
              </InputLeftElement>
              <Input type="text" className="font-poppins text_regular text_md" placeholder="Search name, code, company, branch...." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </InputGroup>

            <Box mt={2} width="230px">
              <DateRangePicker
                maxDate={new Date()}
                onChange={(range) => {
                  if (range) {
                    setDateRange({ from: range.start, to: range.end });
                  } else {
                    setDateRange({ from: firstDayOfMonth, to: today });
                  }
                }}
              />
            </Box>
            <Box mb={2} display="flex" gap={2}>
              <Popover placement="bottom-end" closeOnBlur>
                <PopoverTrigger>
                  <Image src={FilterIcon} alt="Filter" className="icon_btn" cursor="pointer" />
                </PopoverTrigger>
                <FilterPopover filter={filter} onApplyFilter={(filters) => {
                  const _filter: Record<string, number[]> = {};
                  Object.keys(filters).forEach((key) => {
                    if (filters[key].length > 0) {
                      _filter[key.replace(/\s/g, '')] = filters[key];
                    }
                  });

                  setAppliedFilter(_filter);
                  setLazyParams((prev: any) => ({ ...prev, first: 0 }));
                }}
                />
              </Popover>

              <Popover isOpen={sortPop.isOpen} onOpen={sortPop.onOpen} onClose={sortPop.onClose} placement="bottom-end" closeOnBlur>
                <PopoverTrigger>
                  <Image src={SortIcon} alt="Sort" className="icon_btn" cursor="pointer" />
                </PopoverTrigger>
                <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign={'center'}>
                  <Box px={4} py={2} borderBottom="1px solid #eee">
                    <Text className='font-poppins text_sm text_medium' textAlign="center" color={"#00000080"}>Sort By</Text>
                    <PopoverCloseButton top="8px" right="12px" />
                  </Box>
                  <PopoverBody p={0}>
                    {sortOptions.map((option) => (
                      <Box key={option} px={4} py={2} cursor="pointer"
                        bg={selected === option ? '#EBEBEB' : 'white'}
                        _hover={{ bg: '#EBEBEB' }}
                        onClick={() => handleSelect(option)}
                      >
                        <Text className='font-poppins font_dark' fontSize="14px" fontWeight={selected === option ? 600 : 500}>{option}</Text>
                      </Box>
                    ))}
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </Box>
          </Flex>
        </Flex>

        <Box position="relative" minH="400px" mt={3}>
          <CustomTables<any>
            value={employees}
            loading={loading}
            emptyMessage="No Regularisation Requests Found"
            preferenceKey="regularizations"
            showGlobalSearch={false}
            showToolbar={true}
            lazy
            lazyParams={lazyParams}
            onLazyParamsChange={setLazyParams}
            totalRecords={totalCount}
            showPagination
            rowsPerPageOptions={[20, 100, 200, 500]}
            maxTableHeight={null}
          >
            <Column header={(
              <Checkbox colorScheme="green" isChecked={allSelected} isIndeterminate={someSelected && !allSelected}
                onChange={toggleAll} isDisabled={selectable.length === 0}
              />
            )}
              body={(row: any) =>
                (row.status === null && row.canApprove) ? (
                  <Checkbox colorScheme="green" isChecked={selectedRows.includes(row.id)} onChange={() => toggleRow(row.id)} />
                ) : (
                  <></>
                )
              }
            />
            <Column header="Emp. Code" field="employee_Code" sortable filterable filterType="text"
              body={(emp: RegularizationData) => (
                <Badge variant="subtle" className="empId font-poppins text_sm text_regular" cursor="pointer" onClick={() => navigateToDetail(emp.empId)}>{emp.employee_Code}</Badge>
              )}
            />
            <Column header="Name" field="name" sortable filterable filterType="text" />
            <Column header="Company" field="companyName" sortable filterable filterType="text" body={(emp: any) => emp.companyName || "--"} />
            <Column header="Branch" field="branchName" sortable filterable filterType="text" body={(emp: any) => emp.branchName || "--"} />
            <Column header="Date of irregularity" field="dateOfRegularisation" sortable body={(emp: RegularizationData) => (showDate(emp.dateOfRegularisation))} />
            <Column header="In Time" field="inTime" sortable />
            <Column header="Out Time" field="outTime" sortable />
            <Column header="Total Working Hrs" field="totalWorkingHoursFormatted" body={(emp: RegularizationData) => (
              <Text className="font-poppins text_sm text_medium">
                {emp.totalWorkingHoursFormatted || calculateWorkingHours(emp.inTime, emp.outTime)}
              </Text>
            )} />
            <Column header="Department" field="departementName" sortable filterable filterType="text" body={(emp: RegularizationData) => emp.departementName || "--"} />
            <Column header="Manager" field="managerName" sortable filterable border-box filterType="text" body={(emp: RegularizationData) => emp.managerName || "--"} />
            <Column header="Requested Date" field="requested_Date" body={(r: any) => showDate(r.requested_Date)} />
            <Column header="Attendance Status" body={(emp: RegularizationData) => (
              <Text as="span" className={`font-poppins text_sm text_medium ${getStatusClass(emp.attendanceStatus)}`}>
                {getStatusName(emp.attendanceStatus)}
              </Text>
            )}
            />
            <Column header="Expected Status" body={(emp: RegularizationData) => {
              const statusVal = emp.expectedStatus !== undefined && emp.expectedStatus !== null
                ? emp.expectedStatus
                : (emp.totalWorkingHours && emp.totalWorkingHours >= 8 ? 1 : emp.totalWorkingHours && emp.totalWorkingHours >= 4 ? 2 : 4);
              const statusName = emp.expectedStatusName || getStatusName(statusVal) || "Present";
              return (
                <Tooltip label="Attendance status after approval" hasArrow placement="top">
                  <Text as="span" className={`font-poppins text_sm text_medium ${getStatusClass(statusVal)}`}>
                    {statusName}
                  </Text>
                </Tooltip>
              );
            }}
            />
            <Column header="Reason" field="reason" filterable filterType="text" body={(emp: RegularizationData) => (
              <Tooltip label={emp.reason} aria-label="Full reason" hasArrow>
                <Text isTruncated maxW="200px">{emp.reason}</Text>
              </Tooltip>
            )}
            />
            <Column
              header="Status"
              body={(emp: RegularizationData) => {
                const statusLabel = getStatusLabel(emp.status);

                if (emp.canApprove && statusLabel === "Pending") {
                  return (
                    <Select value="Pending" size="sm" width="95px" onChange={(e) => {
                      const value = e.target.value;
                      if (value === "Rejected") {
                        setSelectedRows([emp.id]);
                        setRejectModalOpen(true);
                        return;
                      }
                      setSelectedRows([emp.id]);
                      setApprovedModalOpen(true);
                    }}
                    >
                      <option value="Pending">Pending</option>
                      <option value="Approved">Approve</option>
                      <option value="Rejected">Reject</option>
                    </Select>
                  );
                }

                if (statusLabel === "Rejected") {
                  return (
                    <Tooltip label={emp.rejected_Reason || "No reason provided"} aria-label="Reject reason" hasArrow placement="top" >
                      <Text color="red" cursor="pointer">
                        Rejected by {emp.upadtedByName} ({showDate(emp.updated_At)})
                      </Text>
                    </Tooltip>
                  );
                }

                if (statusLabel === "Approved") {
                  return (
                    <Tooltip label={`Approved by ${emp.upadtedByName} (${showDate(emp.updated_At)})`}  hasArrow
                    >
                      <Text color="green" cursor="pointer">
                        Approved
                      </Text>
                    </Tooltip>
                  );
                }

                return (<Text color="gray">Pending</Text>);
              }}
            />

            <Column header="Attendance" body={(emp: RegularizationData) => (
              <Flex align="center" gap={6}>
                <Text className="view font-poppins text_medium text_sm" onClick={() => handleViewPunchLogs(emp)} cursor="pointer" textDecoration="underline">
                  View
                </Text>
                <Tooltip label="View Regularisation Detail" hasArrow>
                  <CalendarIcon cursor="pointer" color="#006838" boxSize={4} onClick={() => navigateToDetail(emp.empId, emp.dateOfRegularisation)} />
                </Tooltip>
              </Flex>
            )}
            />
            <Column header="Proof" body={(emp: RegularizationData) => emp.proofExists ? (
              <Text className="view font-poppins text_medium text_sm" cursor="pointer" textDecoration="underline" color="blue.500" onClick={() => fetchDocument(emp.id)}>
                Show
              </Text>
            ) : (
              <Text className="font-poppins text_sm" color="gray.400">--</Text>
            )}
            />
          </CustomTables>
        </Box>
      </Box>

      <Modal isOpen={rejectModalOpen} onClose={() => { setRejectModalOpen(false); setRejectedReason(''); }} isCentered size="lg">
        <ModalOverlay />
        <ModalContent borderRadius="12px">
          <ModalHeader className="font-poppins text_medium">Reject Reason</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box height="150px">
              <Textarea placeholder="Enter reject reason..." value={rejectReason} onChange={(e) => setRejectedReason(e.target.value)} className="font-poppins text_regular" height="120px" />
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={() => setRejectModalOpen(false)}>
              Cancel
            </Button>
            <Button isLoading={loadingState} bg="#006838" color="white" ml={3} onClick={() => { if (!rejectReason.trim()) { addToast({ message: "Please enter reason!", status: "warning" }); return; } setRejectModalOpen(false); setAlertStatus(false); }}>
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={approvedModalOpen} onClose={() => { setApprovedModalOpen(false); setApproveReason(''); }} isCentered size="lg">
        <ModalOverlay />
        <ModalContent borderRadius="12px">
          <ModalHeader className="font-poppins text_medium">Approve Reason</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box height="150px">
              <Textarea placeholder="Enter approve reason..." value={approveReason} onChange={(e) => setApproveReason(e.target.value)} className="font-poppins text_regular" height="120px" />
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={() => setApprovedModalOpen(false)}>
              Cancel
            </Button>
            <Button isLoading={loadingState} bg="#006838" color="white" ml={3} onClick={() => { if (!approveReason.trim()) { addToast({ message: "Please enter reason!", status: "warning" }); return; } setApprovedModalOpen(false); setAlertStatus(true); }}>
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={showproof} onClose={() => setShowProof(false)} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center">Proof Of Document</ModalHeader>
          <Divider mb={2} />
          <ModalCloseButton />
          <ModalBody maxH="580px" overflowY="auto" display="flex" justifyContent="center" alignItems="center">
            {documentUrl ? (
              documentType?.includes("pdf") ? (
                <iframe
                  src={`${documentUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                  width="100%"
                  height="600px"
                  style={{ border: "none" }}
                  title="Proof Of Document"
                />
              ) : documentType?.includes("image") ? (
                <img
                  src={documentUrl}
                  alt="Proof Of Document"
                  style={{ maxWidth: "100%", maxHeight: "600px", objectFit: "contain" }}
                />
              ) : (
                <Flex w="100%" h="72vh" justify="center" align="center">
                  <Text className="font-poppins text_regular text_md">No Document Available.</Text>
                </Flex>
              )
            ) : (
              <Flex w="100%" h="72vh" justify="center" align="center">
                <Text className="font-poppins text_regular text_md">No Document Available.</Text>
              </Flex>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={punchModalOpen} onClose={() => { setPunchModalOpen(false); setPunchLogs(null); setPunchEmp(null); }} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader mt={4}>
            Punch Logs – {punchEmp?.name} ({punchEmp ? showDate(punchEmp.dateOfRegularisation) : ''})
          </ModalHeader>
          <ModalBody>
            <CustomTables value={punchLogs?.punchLogs || []} loading={false} emptyMessage="No punches found for this date." maxTableHeight={null}>
              <Column header="ID" body={(_, index) => index + 1} />
              <Column header="Punch Time" body={(log: any) => new Date(log.punchTime).toLocaleTimeString()} />
              <Column header="Punch Type" body={(log: any) => log.punchType?.toUpperCase()} />
            </CustomTables>
          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertCard
        isOpen={alertStatus !== null}
        onClose={() => setAlertStatus(null)}
        isLoading={loadingState}
        onConfirm={confirmStatusChange}
        title={`Confirm Regularisation`}
        description={`Are you sure you want to ${alertStatus === true ? "Approve" : alertStatus === false ? "Reject" : "Keep Pending"} this request?`}
        confirmLabel="Confirm"
        colorScheme={alertStatus === true ? "green" : alertStatus === false ? "red" : "gray"}
      />
    </MyDiv >
  );
};

export default RegularisationList;